

const Footer = () => {
  return (
    <footer className="bg-stone-800 text-white py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
          <div>
            <h3 className="text-2xl font-light mb-6" style={{ fontFamily: '"Pacifico", serif' }}>
              Goldenes Wasser
            </h3>
            <p className="text-stone-300 leading-relaxed mb-6">
              Um refúgio natural para quem busca tranquilidade, 
              descanso e conexão com a natureza.
            </p>
            <div className="flex gap-4">
              <a 
                href="https://wa.me/5547999385389" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-stone-700 rounded-full flex items-center justify-center hover:bg-green-600 transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-whatsapp-line text-lg"></i>
              </a>
              <a 
                href="mailto:contato@casadositio.com.br"
                className="w-10 h-10 bg-stone-700 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-mail-line text-lg"></i>
              </a>
              <a 
                href="#"
                className="w-10 h-10 bg-stone-700 rounded-full flex items-center justify-center hover:bg-pink-600 transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-medium mb-6">Links Rápidos</h4>
            <ul className="space-y-3">
              <li>
                <a href="#sobre" className="text-stone-300 hover:text-white transition-colors duration-300 cursor-pointer">
                  Sobre a Casa
                </a>
              </li>
              <li>
                <a href="#galeria" className="text-stone-300 hover:text-white transition-colors duration-300 cursor-pointer">
                  Galeria
                </a>
              </li>
              <li>
                <a href="#acomodacoes" className="text-stone-300 hover:text-white transition-colors duration-300 cursor-pointer">
                  Acomodações
                </a>
              </li>
              <li>
                <a href="#depoimentos" className="text-stone-300 hover:text-white transition-colors duration-300 cursor-pointer">
                  Depoimentos
                </a>
              </li>
              <li>
                <a href="#reserva" className="text-stone-300 hover:text-white transition-colors duration-300 cursor-pointer">
                  Reserva
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-stone-700 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-stone-400 text-sm">
            © 2024 Goldenes Wasser. Todos os direitos reservados.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-stone-400 hover:text-white text-sm transition-colors duration-300 cursor-pointer mt-4 md:mt-0"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

